import styled from "styled-components";

import { Summary } from "features/shared/styles/typography/Summary.styled";
import FlagContainerPassportPreview from "./FlagContainerPassportPreview";

const StyledPassportPreview = styled.div`
  margin-top: 13px;

  .first-name {
    top: 287px;
    left: 155px;
  }

  .last-name {
    top: 287px;
    left: 283px;
  }

  .passport-number {
    top: 331px;
    left: 155px;
  }

  .gender {
    top: 375px;
    left: 155px;
  }

  .nationality {
    top: 419px;
    left: 155px;
  }

  .birth-date {
    top: 331px;
    left: 283px;
  }

  .expiry-date {
    top: 375px;
    left: 283px;
  }

  ${FlagContainerPassportPreview} {
    top: 424px;
    left: 29px;
  }

  ${Summary} {
    position: absolute;
    top: 16px;
    left: 32px;
    color: ${({ theme }) => theme.colors.base5};
  }
`;

export default StyledPassportPreview;
